"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // TODO be nice to not duplicate this in python and js

var TYPE_STANDARD = exports.TYPE_STANDARD = 1;
var TYPE_FIXED_HORIZONTAL = exports.TYPE_FIXED_HORIZONTAL = 2;
var TYPE_FIXED_VERTICAL = exports.TYPE_FIXED_VERTICAL = 3;
var TYPE_BACK = exports.TYPE_BACK = 4;
var TYPE_URL = exports.TYPE_URL = 5;
var TYPE_ANCHOR = exports.TYPE_ANCHOR = 6;
var TYPE_EMBED = exports.TYPE_EMBED = 7;
var TYPE_VIDEO = exports.TYPE_VIDEO = 8;
var TYPE_POSITION_NORMAL = exports.TYPE_POSITION_NORMAL = 0;
var TYPE_POSITION_LEFT = exports.TYPE_POSITION_LEFT = 1;
var TYPE_POSITION_RIGHT = exports.TYPE_POSITION_RIGHT = 2;
var TYPE_POSITION_TOP = exports.TYPE_POSITION_TOP = 3;
var TYPE_POSITION_BOTTOM = exports.TYPE_POSITION_BOTTOM = 4;
var OVERLAY_CUSTOM = exports.OVERLAY_CUSTOM = 0;
var OVERLAY_CENTERED = exports.OVERLAY_CENTERED = 1;
var OVERLAY_TOP_LEFT = exports.OVERLAY_TOP_LEFT = 2;
var OVERLAY_TOP_CENTER = exports.OVERLAY_TOP_CENTER = 3;
var OVERLAY_TOP_RIGHT = exports.OVERLAY_TOP_RIGHT = 4;
var OVERLAY_BOTTOM_LEFT = exports.OVERLAY_BOTTOM_LEFT = 5;
var OVERLAY_BOTTOM_CENTER = exports.OVERLAY_BOTTOM_CENTER = 6;
var OVERLAY_BOTTOM_RIGHT = exports.OVERLAY_BOTTOM_RIGHT = 7;